import { useEffect, useState } from "react";
import { api } from "../lib/api.js";

interface Pref {
  key: string;
  label: string;
  detail: string;
  enabled: boolean;
  timeOfDay: string | null;
}

export function NotificationSettings() {
  const [prefs, setPrefs] = useState<Pref[] | null>(null);
  const [transportAvailable, setTransportAvailable] = useState(false);

  useEffect(() => {
    api.get<{ prefs: Pref[]; transportAvailable: boolean }>("/api/notifications/prefs")
      .then((r) => { setPrefs(r.prefs); setTransportAvailable(r.transportAvailable); })
      .catch(() => setPrefs([]));
  }, []);

  async function update(key: string, patch: Partial<Pref>) {
    setPrefs((prev) => prev?.map((p) => (p.key === key ? { ...p, ...patch } : p)) ?? prev);
    const pref = prefs?.find((p) => p.key === key);
    if (!pref) return;
    const next = { ...pref, ...patch };
    await api.put(`/api/notifications/prefs/${key}`, { enabled: next.enabled, timeOfDay: next.timeOfDay }).catch(() => undefined);
  }

  return (
    <div className="card">
      <div className="card-header"><span className="card-title">Reminders</span></div>
      {!transportAvailable && (
        <div className="alert alert-info">Delivery isn't switched on yet — your choices are saved and will apply the moment reminders go live. ClovaForm will never spam you; everything's off until you turn it on.</div>
      )}
      {!prefs ? (
        <p className="muted text-sm">Loading…</p>
      ) : (
        <div className="stack">
          {prefs.map((p) => (
            <div key={p.key} className="notif-row">
              <label className="switch">
                <input type="checkbox" checked={p.enabled} onChange={(e) => update(p.key, { enabled: e.target.checked })} />
                <span className="switch-track" />
              </label>
              <div className="grow" style={{ minWidth: 0 }}>
                <div style={{ fontWeight: 600 }}>{p.label}</div>
                <div className="muted text-sm">{p.detail}</div>
              </div>
              {p.enabled && (
                <input
                  type="time"
                  className="input"
                  style={{ width: 118, minHeight: 38 }}
                  value={p.timeOfDay ?? ""}
                  onChange={(e) => update(p.key, { timeOfDay: e.target.value || null })}
                />
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
